import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { SohoDataGridComponent } from "ids-enterprise-ng";
import { CapacityModelService } from "../services/CapacityModel-Service";
import { Router, NavigationExtras } from "@angular/router";
import { SohoModalDialogService, SohoBusyIndicatorDirective } from 'ids-enterprise-ng';
import { AuthHelper } from './../services/authHelper';
import { UserData } from '../shared/models/user.model';
import { filterPayCurveColumns } from '../services/fiscal-year.helper';

@Component({
  selector: 'app-quota-input-gic',
  templateUrl: './quota-input-gic.component.html',
  styleUrls: ['./quota-input-gic.component.css']
})
export class QuotaInputGicComponent implements OnInit {
  @ViewChild(SohoDataGridComponent) datagrid!: SohoDataGridComponent;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;
  showBusy = true;
  Message = "Loading...";
  public data!: any[];
  public grid_Columns!: SohoDataGridColumn[];
  public GrdRequests: any;
  public filteredRequests: any;
  public filteredArray: any[] = [];
  public filteredIds: any[] = [];
  public filteredCreatedBy: any[] = [];
  emailAddress!: string;
  userData = new UserData();

  constructor(private capacityModelService: CapacityModelService,
    private router: Router,
    private modalService: SohoModalDialogService,
    private authhelper: AuthHelper,
    private ngZone: NgZone) { }

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData == null || this.userData == undefined ||  this.userData.Email == "" || this.userData.SecurityroleDescription == "") {
      this.authhelper.setUserRoleAndLoginDetails();
    }
    this.emailAddress = this.userData.Email;
    this.GetQuotasReadyForPlanCreation();
  }
  GetQuotasReadyForPlanCreation() {
    this.data = [];
    this.grid_Columns = [];
    this.start();
    this.capacityModelService.GetQuotaInputsSubmitted(this.userData.Email).subscribe(
      detailedquotas => {
        this.data = detailedquotas;
        this.grid_Columns = filterPayCurveColumns(this.gridColumns);
        if (this.data != null) {
          this.GrdRequests = $("#QuotaApprovedatagrid").datagrid().data();
          this.GrdRequests.datagrid.renderRows();
          this.stop();
        }
      },
      (error: Response) => {
        this.stop();
        console.log(error);
      }
    );

  }
  CreatePlans() {
    this.InitiatePlanCreation();
  }
  RejectQuotas() {
    this.RejectQuotasWithComment();
  }
  InitiatePlanCreation() {
    let selectedid: any[] = [];
    let filterid!: any;
    this.filteredArray = [];
    var selectedRowsCount = this.GrdRequests.datagrid.selectedRows().length;
    //console.log(selectedRowsCount);
    if (selectedRowsCount <= 0) {
      this.filteredArray = [];
    }
    else {

      for (var i = 0; i < selectedRowsCount; i++) {
        this.filteredRequests = false;
        if (this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered == undefined) {
          this.filteredRequests = true
        }
        else if (!this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered) {
          this.filteredRequests = true
        }
        if (this.filteredRequests) {
          this.filteredIds = this.GrdRequests.datagrid.selectedRows()[i].data.uniqueid;
          this.filteredArray.push(this.filteredIds);
        }

      }
    }
    if (this.filteredArray.length > 0) {
      this.start();
      for (var i = 0; i < this.filteredArray.length; i++) {
        filterid = <JSON><unknown>{ "uniqueid": this.filteredArray[i], "userlogin": this.emailAddress == null ? "rameshbabu.kollu@infor.com" : this.emailAddress };
        selectedid.push(filterid);
      }
      this.capacityModelService.CreatePlansForTheSelectedQuotas(selectedid).subscribe(
        response => {
          //console.log(response.body.ErrorMessage);
          if (response.ErrorMessage != "")
            this.ShowAlert("Confirmation", response.ErrorMessage);
          else
            this.ShowAlert("Confirmation", "Plans created successfully.");
          this.stop();
          this.GetQuotasReadyForPlanCreation();
        },
        (err: Response) => {
          console.log(err);
          this.stop();
          this.ShowAlert("Alert", err);
          this.ShowAlert("Alert", "Error while creating the plans.");
        }
      );
    }
    else {
      this.ShowAlert("Information", "Please select atleast one Quota to submit.");
    }
  }
  RejectQuotasWithComment() {
    let selectedid: any[] = [];
    let filterid!: any;
    this.filteredArray = [];
    this.filteredCreatedBy = [];
    var selectedRowsCount = this.GrdRequests.datagrid.selectedRows().length;
    //console.log(selectedRowsCount);
    if (selectedRowsCount <= 0) {
      this.filteredArray = [];
    }
    else {

      for (var i = 0; i < selectedRowsCount; i++) {
        this.filteredRequests = false;
        if (this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered == undefined) {
          this.filteredRequests = true
        }
        else if (!this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered) {
          this.filteredRequests = true
        }
        if (this.filteredRequests) {
          this.filteredIds = this.GrdRequests.datagrid.selectedRows()[i].data.uniqueid;
          this.filteredArray.push(this.filteredIds);
          this.filteredCreatedBy.push(this.GrdRequests.datagrid.selectedRows()[i].data.createdby);
        }

      }
    }
    if (this.filteredArray.length > 0) {
      this.start();
      for (var i = 0; i < this.filteredArray.length; i++) {
        filterid = <JSON><unknown>{ "uniqueid": this.filteredArray[i], "userlogin": this.emailAddress == null ? "rameshbabu.kollu@infor.com" : this.emailAddress,"createdby":this.filteredCreatedBy[i] };
        selectedid.push(filterid);
      }
      this.capacityModelService.RejectQuotaInputs(selectedid).subscribe(
        response => {
          this.ShowAlert("Confirmation", "Selected Quotas sent back to Finance for review.");
          this.stop();
          this.GetQuotasReadyForPlanCreation();
        },
        (error: Response) => {
          console.log(error);
          this.stop();
          this.ShowAlert("Alert", "Error while rejecting the Quotas.");
        }
      );
    }
    else {
      this.ShowAlert("Information", "Please select atleast one Quota to reject.");
    }
  }
  ShowAlert(Title: any, Message: any) {
    const dialogRef1 = this.modalService
      .message("<h2>" + Message + "</h2>")
      .buttons([
        {
          text: "Ok",
          click: () => {
            dialogRef1.close("Ok");

          },
          isDefault: true
        }
      ])
      .title(Title)
      .open()
      .frameHeight(1000);
  }
  start() {
    (this.busyIndicator as any).activated = true;
  }
  stop() {
    (this.busyIndicator as any).activated = false;
  }
  gridColumns = [
    {
      id: 'selectionCheckbox',
      sortable: false,
      resizable: false,
      formatter: Soho.Formatters.SelectionCheckbox,
      align: 'center'
    },
    //{
    //   id: "button-formatter",
    //   name: "Actions",
    //   text: "Delete Row",
    //   sortable: true,
    //   icon: "delete",
    //   align: "center",
    //   formatter: Soho.Formatters.Button,
    //   click: (args: any) => this.onClick(args)
    // },
    {
      id: "uniqueid",
      name: "Unique ID",
      field: "uniqueid",
      hidden: true,
      formatter: Soho.Formatters.Text
    },
    {
      id: "employeeid",
      name: "Employee ID",
      sortable: true,
      field: "employeeid",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "employeename",
      name: "Employee Name",
      field: "employeename",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "plantype",
      name: "Plan Type",
      field: "plantype",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "variablepay",
      name: "Variable Pay",
      field: "variablepay",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "variablepaycurrency",
      name: "Variable Pay Currency",
      field: "variablepaycurrency",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "planstartdate",
      name: "Plan Startdate",
      field: "planstartdate",
      filterType: 'date',
      formatter: Soho.Formatters.Date,
      dateFormat: 'M/d/yyyy'
    },
    {
      id: "planenddate",
      name: "Plan Enddate",
      field: "planenddate",
      filterType: 'date',
      formatter: Soho.Formatters.Date,
      dateFormat: 'M/d/yyyy'
    },
    {
      id: "variabletype",
      name: "Variable Type",
      field: "variabletype",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "reprole",
      name: "Rep Role",
      field: "reprole",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "salesunit",
      name: "Sales Unit",
      field: "salesunit",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "lob",
      name: "LOB",
      field: "lob",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "totalquotausd",
      name: "Total Quota USD",
      field: "totalquotausd",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true, style: 'currency' }
    },
    {
      id: "element1",
      name: "Element 1",
      field: "element1",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "paycurve1",
      name: "Pay Curve 1",
      field: "paycurve1",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "territorygroup",
      name: "Territory Group1",
      field: "territorygroup",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "totalquota",
      name: "Total Quota 1",
      field: "totalquota",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2}
    },
    {
      id: "proratedtotalquota1",
      name: "Prorated Total Quota 1",
      field: "proratedtotalquota1",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    },
    {
      id: "element2",
      name: "Element 2",
      field: "element2",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "paycurve2",
      name: "Pay Curve 2",
      field: "paycurve2",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "territorygroup2",
      name: "Territory Group2",
      field: "territorygroup2",
      filterType: 'text',

      formatter: Soho.Formatters.Text
    },
    {
      id: "totalquota2",
      name: "Total Quota 2",
      field: "totalquota2",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    },
    {
      id: "proratedtotalquota2",
      name: "Prorated Total Quota 2",
      field: "proratedtotalquota2",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    },
    {
      id: "element3",
      name: "Element 3",
      field: "element3",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "paycurve3",
      name: "Pay Curve 3",
      field: "paycurve3",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "territorygroup3",
      name: "Territory Group3",
      field: "territorygroup3",
      filterType: 'text',

      formatter: Soho.Formatters.Text
    },
    {
      id: "totalquota3",
      name: "Total Quota 3",
      field: "totalquota3",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    },
    {
      id: "proratedtotalquota3",
      name: "Prorated Total Quota 3",
      field: "proratedtotalquota3",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    },
    {
      id: "element4",
      name: "Element 4",
      field: "element4",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "paycurve4",
      name: "Pay Curve 4",
      field: "paycurve4",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "territorygroup4",
      name: "Territory Group4",
      field: "territorygroup4",
      filterType: 'text',

      formatter: Soho.Formatters.Text
    },
    {
      id: "totalquota4",
      name: "Total Quota 4",
      field: "totalquota4",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    },
    {
      id: "proratedtotalquota4",
      name: "Prorated Total Quota 4",
      field: "proratedtotalquota4",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    },
    {
      id: "element5",
      name: "Element 5",
      field: "element5",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "paycurve5",
      name: "Pay Curve 5",
      field: "paycurve5",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "territorygroup5",
      name: "Territory Group5",
      field: "territorygroup5",
      filterType: 'text',

      formatter: Soho.Formatters.Text
    },
    {
      id: "totalquota5",
      name: "Total Quota 5",
      field: "totalquota5",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    },
    {
      id: "q1_1",
      name: "Element 1 Q1",
      field: "q1_1",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q2_1",
      name: "Element 1 Q2",
      field: "q2_1",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q3_1",
      name: "Element 1 Q3",
      field: "q3_1",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q4_1",
      name: "Element 1 Q4",
      field: "q4_1",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q1_2",
      name: "Element 2 Q1",
      field: "q1_2",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q2_2",
      name: "Element 2 Q2",
      field: "q2_2",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q3_2",
      name: "Element 2 Q3",
      field: "q3_2",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q4_2",
      name: "Element 2 Q4",
      field: "q4_2",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q1_3",
      name: "Element 3 Q1",
      field: "q1_3",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q2_3",
      name: "Element 3 Q2",
      field: "q2_3",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q3_3",
      name: "Element 3 Q3",
      field: "q3_3",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q4_3",
      name: "Element 3 Q4",
      field: "q4_3",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q1_4",
      name: "Element 4 Q1",
      field: "q1_4",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q2_4",
      name: "Element 4 Q2",
      field: "q2_4",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q3_4",
      name: "Element 4 Q3",
      field: "q3_4",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q4_4",
      name: "Element 4 Q4",
      field: "q4_4",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q1_5",
      name: "Element 5 Q1",
      field: "q1_5",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q2_5",
      name: "Element 5 Q2",
      field: "q2_5",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q3_5",
      name: "Element 5 Q3",
      field: "q3_5",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q4_5",
      name: "Element 5 Q4",
      field: "q4_5",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "fiscalyear",
      name: "Fiscalyear",
      field: "fiscalyear",
      formatter: Soho.Formatters.Text
    },
    {
      id: "perpetualmultiplier",
      name: "Perpetual Multiplier",
      field: "perpetualmultiplier",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "saasmultiplierlt3years",
      name: "SaaS Multiplier < 1 Year",
      field: "saasmultipliergt2lt3years",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "saasmultipliergt1lt2years",
      name: "SaaS Multiplier > 1 and < 2 Years",
      field: "saasmultipliergt1lt2years",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "saasmultipliergt3years",
      name: "SaaS Multiplier > 2 Years",
      field: "saasmultipliergt3years",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    // {
    //   id: "perpetuallogomultiplier",
    //   name: "MES Multiplier",
    //   field: "perpetuallogomultiplier",
    //   filterType: 'decimal',
    //   formatter: Soho.Formatters.Decimal,
    //   numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    // },
    {
      id: "gicrejected",
      name: "GIC Rejected",
      field: "gicrejected",
      formatter: Soho.Formatters.Text
    },
    {
      id: "batchid",
      name: "Batch ID",
      field: "batchid",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "commentsadded",
      name: "Comments Added",
      field: "commentsadded",
      formatter: Soho.Formatters.Text
    },
    {
      id: "createdby",
      name: "Created By",
      field: "createdby",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "created",
      name: "Created On",
      field: "created",
      filterType: 'date',
      formatter: Soho.Formatters.Date,
      dateFormat: 'M/d/yyyy hh:mm:ss'
    }
  ];
}
